module.exports = __webpack_public_path__ + "img/vmc_aniv21_24Aug2021.b486d777.jpg";